import { generateKeyVariations, isParamTranslatable } from '../../generateKey';
import { paramShouldInheritDesktop } from '../../utils/paramShouldInheritDesktop';
import { getTranslationDefaultFunction } from './translationDefaultFunction';
import { ValueSerializer } from './ValueSerializer';
var serializer = new ValueSerializer();
export function getSettingsValue(values, param, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var isTranslatableParam = isParamTranslatable(param);
    var keys = generateKeyVariations(param, {
        isMobile: options.isMobile,
        language: isTranslatableParam ? options.language : undefined,
    });
    var shouldInheritDesktop = paramShouldInheritDesktop(param);
    var value;
    if (isTranslatableParam) {
        if (typeof values[keys.languageAndMobile] !== 'undefined') {
            value = values[keys.languageAndMobile];
        }
        else if (shouldInheritDesktop &&
            typeof values[keys.language] !== 'undefined') {
            value = values[keys.language];
        }
        // tslint:disable-next-line
    }
    else {
        if (typeof values[keys.mobile] !== 'undefined') {
            value = values[keys.mobile];
        }
        else if (shouldInheritDesktop &&
            typeof values[keys.original] !== 'undefined') {
            value = values[keys.original];
        }
    }
    if (typeof value === 'undefined') {
        return param.getDefaultValue({
            isMobile: options.isMobile,
            isRTL: options.isRTL,
            t: (_a = options.t) !== null && _a !== void 0 ? _a : getTranslationDefaultFunction({
                environmentLabel: (_b = options.environmentLabel) !== null && _b !== void 0 ? _b : '`getSettingsValue` function',
            }),
        });
    }
    return serializer.deserialize(param, value);
}
//# sourceMappingURL=getSettingsValue.js.map